export default __webpack_public_path__ + "static/media/slides-guide-3.bcae0276.svg";